module.exports = __webpack_public_path__ + "static/media/Search Sanctions Person Name.bbae95b4.xlsx";